const ProductCenter = () => import('~/views/ProductCenter/ListView.vue')

export {
  ProductCenter
}
